import {Tabs,Tab, TabContent, Container,Button, Row } from "react-bootstrap";
import ProductCardElement from "../productSlider/utility";
import "./style.css";
import React from "react";

function NewProduct(props) {
  const [isLoading, setIsLoading] = React.useState(true);
  const [slides, setSlides] = React.useState();

  React.useEffect(() => {
    const fetchnewsong = async () => {
      const response = await fetch(process.env.REACT_APP_API_URL + `/api/getnewest`);
      const data = response.ok ? await response.json() : [];
      setSlides(Array.isArray(data) ? data.slice(0, props.limit) : []);
    };
    fetchnewsong();
  }, []);
  React.useEffect(() => {
    if (slides) {
      setIsLoading(false);
    }
  }, [slides]);
  if (isLoading) {
    // Render a skeleton grid with the SAME layout/height as the loaded cards so
    // the swap from loading to content does not shift the page (CLS fix).
    const placeholders = Array.from({ length: props.limit || 8 });
    return (
      <div className="productTabs">
        <Container className="mb-4">
          <Row>
            <h2 className="text-left mb-4 ms-4">最新上傳</h2>
            <div className="row">
              {placeholders.map((_, index) => (
                <div className="col-md-3 mb-4" key={index}>
                  <Container>
                    <div className="product-skeleton" aria-hidden="true">
                      <div className="product-skeleton-img" />
                      <div className="product-skeleton-line" />
                      <div className="product-skeleton-line short" />
                    </div>
                  </Container>
                </div>
              ))}
            </div>
          </Row>
        </Container>
      </div>
    );
  }
  return (
    <div className="productTabs">
      <Container className="mb-4">
        <Row>
      <h2 className="text-left mb-4 ms-4">最新上傳</h2>

        <div className="row">
          {slides.map((slide, index) => (
            <div className="col-md-3 mb-4" key={index}>
              <Container>
                <ProductCardElement slidePro={slide} />
              </Container>
            </div>
          ))}
        </div>
        <Button className="mb-4" variant="secondary" onClick={() => window.location.href = '/products'}>查看更多</Button>
        </Row>
      </Container>
    </div>
  );
}

export default NewProduct;
